/* eslint-disable */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
  JobFilterModal,
  JobSearchContainer,
  JobAlertModal,
  JobAlertPopover,
} from 'pages/jobs/JobPosts.style';
import {
  getCountryList,
  getJobTypeList,
  getWorkTypeList,
} from 'redux/features/DropDownSlice';
import { CountryCode } from 'redux/features/LoginSlice';
import { useDispatch, useSelector } from 'react-redux';
import { DialogActions, Divider, Drawer, InputAdornment } from '@mui/material';
import {
  BasicIconButton,
  BrandIconSpinner,
  Button,
  CloseIcon,
  Input,
  Modal,
  Select,
} from 'components';
import CheckBox from 'components/CheckBox';
import BasicPopover from 'components/Popover';
import { PostBox } from 'pages/home/Home.style';
import { Notification } from 'components/CustomNotification';
import {
  JobAlertPost,
  JobAlertUpdate,
  GetAllJobAlert,
  deleteJobAlertById,
  getJobPostList,
} from 'redux/features/PostJobSlice';

import { ReactComponent as Filter } from 'assert/images/Common/filter.svg';
import { ReactComponent as Search } from 'assert/images/Home/search.svg';
import { ReactComponent as JobAlert } from 'assert/images/Jobs/addAlert.svg';
import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import { ReactComponent as Edit } from 'assert/images/More/postEdit.svg';
import { ClearLoading, SetLoading } from 'redux/services/LoadingService';
import { useTranslation } from 'react-i18next';
import AutoComplete from 'components/AutoComplete';
import { jobPageSize } from './JobList';
import { AuthContext } from 'router/AuthProvider';
import LoginNotification from 'pages/auth/LoginNotification';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';
import useWindowDimensions from 'components/Dimention';
import { swipeModalWidth } from 'utils/helper';

const initialFilterState = {
  title: '',
  location: '',
  datePosted: '',
  workType: [],
  jobType: [],
  easyApply: false,
};

export default function JobFilter({
  page,
  hanldeResetPage,
  onlyAlert,
  children,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isLoggedIn } = useContext(AuthContext);
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const { jobList, workTypeList, countryList } = useSelector(
    (state) => state?.DropdownReducer
  );
  const { rows } = useSelector((state) => state?.PostJobReducer?.jobPostList);

  const Countrycode = useSelector((state) => state?.LoginReducer?.countryCode);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const [jobModalOpen, setJobModalOpen] = useState(false);
  const [filterState, setFilterState] = useState(initialFilterState);
  const [alertState, setAlertState] = useState();
  const [alertList, setAlertList] = useState([]);
  const [isFilter, setIsFilter] = useState(false);
  const [updateIdAlert, setUpdateIdAlert] = useState(null);
  const [isAlertPopoverOpen, setIsAlertPopoverOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoginNotificationOpen, setIsLoginNotificationOpen] = useState(false);

  const filterURL = `jobPost/fetchAll/${getProfile?.userId}?title=${
    filterState.title
  }&filterlocation=${filterState?.location?.value || ''}&interval=${
    filterState?.datePosted
  }&workType=${filterState.workType}&jobType=${filterState.jobType}&easyApply=${
    filterState.easyApply
  }&page=${
    page || 0
  }&size=${jobPageSize}&clientOffSet=${new Date().getTimezoneOffset()}`;

  const initialAlertState = {
    title: '',
    location: '',
    workType: [],
    jobType: [],
    email: getProfile?.userEmail,
  };

  useEffect(() => {
    !Countrycode?.country_code && dispatch(CountryCode());
    jobList?.length === 0 && dispatch(getJobTypeList());
    workTypeList?.length === 0 && dispatch(getWorkTypeList());
    countryList?.length === 0 && dispatch(getCountryList());
  }, []);

  useEffect(() => {
    if (getProfile?.userEmail) {
      setAlertState(initialAlertState);
    }
  }, [getProfile?.userEmail]);

  useEffect(() => {
    if (!isFilter && isLoggedIn) {
      setLoading(true);
      dispatch(GetAllJobAlert())
        .then((res) => {
          setAlertList(res?.data);
          setLoading(false);
        })
        .catch((err) => {
          Notification('warning', err.response?.data?.message);
          setLoading(false);
        });
    }
  }, [isFilter]);

  const handleFilterChange = (data, name) => {
    setFilterState((prevState) => ({
      ...prevState,
      [name]: data?.target?.value || data,
    }));
  };

  useEffect(() => {
    if (isLoggedIn && rows) {
      const payload = {
        url: filterURL,
      };
      dispatch(getJobPostList(payload)).then(() => {
        setIsFilter(false);
        setJobModalOpen(false);
      });
    }
  }, [isLoggedIn, page]);

  const handleFilterSubmit = () => {
    hanldeResetPage(0);
    const payload = {
      url: filterURL,
    };
    dispatch(getJobPostList(payload)).then(() => {
      setIsFilter(false);
      setJobModalOpen(false);
    });
  };

  const handleAlertChange = (data, name) => {
    setAlertState((prevState) => ({
      ...prevState,
      [name]: data?.target?.value || data,
    }));
  };

  const handleAlertSubmit = () => {
    setLoading(true);
    dispatch(SetLoading());
    dispatch(JobAlertPost(alertState))
      .then((res) => {
        setAlertList([
          ...alertList,
          {
            ...alertState,
            id: res?.data?.data?.id,
          },
        ]);
        setAlertState(initialAlertState);
        setLoading(false);
      })
      .catch((err) => {
        Notification('warning', err.response?.data?.message);
        setAlertState(initialAlertState);
        setLoading(false);
      });
    dispatch(ClearLoading());
  };

  const handleAlertUpdate = () => {
    setLoading(true);
    dispatch(JobAlertUpdate(alertState, updateIdAlert))
      .then(() => {
        const itemIndex = alertList.findIndex(
          (item) => item?.id === updateIdAlert
        );
        alertList[itemIndex] = alertState;
        setUpdateIdAlert(null);
        setAlertState(initialAlertState);
        setLoading(false);
      })
      .catch((err) => {
        Notification('warning', err.response?.data?.message);
        setLoading(false);
      });
  };

  const handleSetIndex = (id) => {
    const savedState = alertList.find((item) => item?.id === id);
    setUpdateIdAlert(id);
    setAlertState({
      id: savedState?.id,
      title: savedState?.title,
      location: savedState?.location,
      workType: savedState?.workType,
      jobType: savedState?.jobType,
      email: getProfile?.userEmail,
    });
  };

  const handleDeleteAlert = (id) => {
    setLoading(true);
    dispatch(deleteJobAlertById(id))
      .then((res) => {
        Notification('success', res?.data?.message);
        const newList = alertList.filter((item) => item?.id !== id);
        setAlertList(newList);
        setLoading(false);
        setIsAlertPopoverOpen(false);
      })
      .catch((err) => {
        Notification('warning', err.response?.data?.message);
        setLoading(false);
      });
  };

  const jobFilterContent = () => {
    return (
      <JobFilterModal>
        <CloseIcon
          customStyle="job-filter-close-icon"
          onClick={() => setIsFilter(false)}
        />
        <div className="job-filter-title">{t('Job.Filter')}</div>
        <div className="row-btn">
          <Select
            label={t('Job.DatePosted')}
            value={filterState.datePosted}
            onChange={(data) => handleFilterChange(data, 'datePosted')}
            Options={[
              { label: 'Today', value: 1 },
              { label: 'Last 2 Days', value: 2 },
              { label: 'Last 7 Days', value: 7 },
              { label: 'Last 15 Days', value: 15 },
              { label: 'Last 30 Days', value: 30 },
            ]}
          />
          <Select
            label={t('Job.WorkType')}
            value={filterState.workType}
            onChange={(data) => handleFilterChange(data, 'workType')}
            Options={workTypeList}
            mode="multiple"
          />
        </div>
        <Select
          label={t('Job.EmploymentType')}
          value={filterState.jobType}
          onChange={(data) => handleFilterChange(data, 'jobType')}
          Options={jobList}
          mode="multiple"
        />
        <CheckBox
          label={t('Job.QuickApply')}
          value={filterState.easyApply}
          onChange={(data) => handleFilterChange(data, 'easyApply')}
        />
        <DialogActions>
          <Button
            variant="text"
            label={t('Job.Apply')}
            customStyles="cancel-btn"
            onClick={handleFilterSubmit}
          />
          <Button
            variant="text"
            label={t('Job.ResetAll')}
            customStyles="cancel-btn"
            onClick={() => setFilterState(initialFilterState)}
          />
        </DialogActions>
      </JobFilterModal>
    );
  };

  const jobAlertContent = () => {
    return (
      <JobAlertModal>
        <BrandIconSpinner loading={loading} />
        <div className="row-btn">
          <Input
            required
            value={alertState?.title}
            onChange={(data) => handleAlertChange(data, 'title')}
            label={t('Job.TitleOrSkill')}
          />
          <AutoComplete
            Options={countryList}
            label={t('Job.Location')}
            value={alertState.location}
            onChange={(data) => handleAlertChange(data?.value, 'location')}
            // errMsg={errMsg.location}
          />
        </div>
        <div className="row-btn">
          <Select
            label={t('Job.WorkType')}
            value={alertState.workType}
            onChange={(data) => handleAlertChange(data, 'workType')}
            Options={workTypeList}
            mode="multiple"
          />
          <Select
            label={t('Job.EmploymentType')}
            value={alertState.jobType}
            onChange={(data) => handleAlertChange(data, 'jobType')}
            Options={jobList}
            mode="multiple"
          />
        </div>
        <div className="row-btn row-btn-grid">
          <div>
            <h4>{t('Job.ReceiveAlert')}</h4>
            <div>{getProfile?.userEmail}</div>
          </div>
          <div className="job-alert-footer">
            {updateIdAlert === null ? (
              <Button
                variant="outlined"
                disabled={!alertState.title || alertList?.length >= 5}
                label={t('Job.Create')}
                customStyles="cancel-btn"
                onClick={handleAlertSubmit}
              />
            ) : (
              <>
                <Button
                  variant="outlined"
                  disabled={!alertState.title}
                  label="Update"
                  customStyles="cancel-btn"
                  onClick={handleAlertUpdate}
                />
                <Button
                  variant="outlined"
                  label="Cancel"
                  customStyles="cancel-btn"
                  onClick={() => {
                    setFilterState(initialFilterState);
                    setAlertState(initialAlertState);
                    setUpdateIdAlert(null);
                  }}
                />
              </>
            )}
          </div>
        </div>

        {alertList?.length > 0 && (
          <>
            <Divider />
            <h4>Saved job alert</h4>
          </>
        )}
        {alertList.map((data, index) => {
          return (
            <PostBox key={index}>
              <div className="alert-action">
                <BasicIconButton
                  size="small"
                  className="job-alert-edit"
                  disabled={updateIdAlert !== null}
                  icon={<Edit />}
                  color="primary"
                  onClick={() => handleSetIndex(data.id)}
                />
                <BasicPopover
                  disabled={updateIdAlert !== null}
                  handlePopoverClick={() => setIsAlertPopoverOpen(true)}
                  isOpen={isAlertPopoverOpen}
                  action={
                    <BasicIconButton
                      size="small"
                      disabled={updateIdAlert !== null}
                      icon={<Delete />}
                      color="error"
                    />
                  }
                  content={
                    <JobAlertPopover className="job-alert-popover">
                      Are you sure you want to delete?
                      <div>
                        <Button
                          variant="text"
                          color="error"
                          label="Yes"
                          onClick={() => handleDeleteAlert(data.id)}
                        />
                        <Button
                          variant="text"
                          label="No"
                          onClick={() => setIsAlertPopoverOpen(false)}
                        />
                      </div>
                    </JobAlertPopover>
                  }
                />
              </div>
              <div className="label-block">
                <div>Title</div>
                <div>{data.title}</div>
              </div>
              <div className="label-block">
                <div>Location</div>
                <div>
                  {countryList.find((ele) => ele.value === data.location)
                    ?.label || '---'}
                </div>
              </div>
              <div className="label-block">
                <div>Work Type</div>
                <div>
                  {data.workType?.length > 0
                    ? data.workType?.map((itemId, index) => {
                        return (
                          <span key={index}>
                            {
                              workTypeList.find(
                                (workTypeItem) => workTypeItem.value == itemId
                              )?.label
                            }
                            {data.workType?.length !== index + 1 && ',  '}
                          </span>
                        );
                      })
                    : '---'}
                </div>
              </div>
              <div className="label-block">
                <div>Employment Type</div>
                <div>
                  {data.jobType?.length > 0
                    ? data.jobType?.map((itemId, index) => {
                        return (
                          <span key={index}>
                            {
                              jobList.find(
                                (workTypeItem) => workTypeItem.value == itemId
                              )?.label
                            }
                            {data.jobType?.length !== index + 1 && ',  '}
                          </span>
                        );
                      })
                    : '---'}
                </div>
              </div>
            </PostBox>
          );
        })}
      </JobAlertModal>
    );
  };

  const screenWidth = screen.availWidth <= 500;

  return (
    <>
      {!onlyAlert ? (
        <JobSearchContainer className="JobSearchContainer">
          <div className="search-input-container">
            <div className="search-title">
              <Input
                onClick={
                  isLoggedIn ? () => {} : () => setIsLoginNotificationOpen(true)
                }
                value={filterState.title}
                onChange={(data) => {
                  if (isLoggedIn) {
                    handleFilterChange(data, 'title');
                  } else {
                    setIsLoginNotificationOpen(true);
                  }
                }}
                placeholder={t('Job.TitleSkill')}
                startAdornment={
                  !screenWidth ? (
                    <InputAdornment>
                      <Search />
                    </InputAdornment>
                  ) : (
                    <></>
                  )
                }
              />
            </div>
            <div className="search-location">
              <AutoComplete
                value={filterState.location}
                onChange={(data) => {
                  if (isLoggedIn) {
                    handleFilterChange(data, 'location');
                  } else {
                    setIsLoginNotificationOpen(true);
                  }
                }}
                textPlaceholder={t('Job.Location')}
                Options={countryList}
              />
            </div>
            <div className="search-btn">
              {!screenWidth ? (
                <div>
                  <Button
                    variant="outlined"
                    label={t('Job.Search')}
                    onClick={() => {
                      if (isLoggedIn) {
                        handleFilterSubmit();
                      } else {
                        setIsLoginNotificationOpen(true);
                      }
                    }}
                  />
                </div>
              ) : (
                <div className="job-filter-btn">
                  <Button
                    variant="outlined"
                    startIcon={<Search />}
                    onClick={() => {
                      if (isLoggedIn) {
                        handleFilterSubmit();
                      } else {
                        setIsLoginNotificationOpen(true);
                      }
                    }}
                  />
                </div>
              )}
              <div className="job-filter-btn">
                <Button
                  variant="outlined"
                  startIcon={<Filter />}
                  onClick={() => {
                    if (isLoggedIn) {
                      setIsFilter(true);
                    } else {
                      setIsLoginNotificationOpen(true);
                    }
                  }}
                />
              </div>
            </div>
            {!screenWidth && (
              <div className="job-alert">
                <Button
                  variant="outlined"
                  label={<JobAlert />}
                  onClick={() => {
                    if (isLoggedIn) {
                      setJobModalOpen(!jobModalOpen);
                      setIsFilter(false);
                    } else {
                      setIsLoginNotificationOpen(true);
                    }
                  }}
                />
              </div>
            )}
          </div>
        </JobSearchContainer>
      ) : (
        <span
          onClick={() => {
            setJobModalOpen(!jobModalOpen);
            setIsFilter(false);
          }}
        >
          {children}
        </span>
      )}
      {isSmallScreen ? (
        <SwipeableEdgeDrawer
          title={t('Job.Alert')}
          openDrawer={jobModalOpen}
          handleCloseDrawer={() => setJobModalOpen(!jobModalOpen)}
        >
          {jobModalOpen && jobAlertContent()}
        </SwipeableEdgeDrawer>
      ) : (
        <Modal
          content={jobModalOpen && jobAlertContent()}
          openModal={jobModalOpen}
          handleCancelModal={() => setJobModalOpen(!jobModalOpen)}
          modelTitle={t('Job.Alert')}
          modalchanges={'job-alert'}
          fullWidth={true}
          maxWidth={'sm'}
        />
      )}
      <Drawer
        anchor={'right'}
        open={isFilter}
        onClose={() => setIsFilter(false)}
        className="job-filter"
      >
        {jobFilterContent()}
      </Drawer>
      <LoginNotification
        isLoginNotificationOpen={isLoginNotificationOpen}
        handleUpdateModal={() => {
          setIsLoginNotificationOpen(false);
        }}
      />
    </>
  );
}
